module.exports = __webpack_public_path__ + "img/slide2.31859e01.jpg";